import React from 'react'
import PropTypes from 'prop-types'
import CustomModal from '../UI/Modals/CustomModal'
import Paragraph from '../UI/Texts/Paragraph'
import ErrorIcon from '@mui/icons-material/Error';
import './styles.css'

const PedidoErrorPago = ({
  classes,
  openModalCompraNoExitosa,
  handleOnClickEntendido,
  nombreFantasia
}) => {
  return <CustomModal
    open={openModalCompraNoExitosa}
    onClose={() => { }}
    title={
      <div style={{ display: 'flex', alignItems: 'center'}}>
        <ErrorIcon style={{ color: 'rgba(255, 0, 0, 0.5)', marginRight: 8 }} />
        COMPRA FALLIDA
      </div>
    }
    buttonNames={["¡ENTENDIDO!"]}
    buttonActions={
      [handleOnClickEntendido]
    }
  >
    <div className='modalTextContent'>
      <div style={{marginBottom: '10px'}}>
        <Paragraph size="big" weight="bold">
          Problema en el procesamiento de tu compra
        </Paragraph>
      </div>
      <div style={{marginBottom: '10px'}}>
        <Paragraph size="big" weight="regular">
          Lamentamos informarte que hemos encontrado un inconveniente al procesar tu pedido.
        </Paragraph>
        <Paragraph size="big" weight="regular">
          Intente realizarla nuevamente, si el problema persiste, no dudes en contactar a nuestro equipo de soporte.
        </Paragraph>     
      </div>
      <div>
        <Paragraph size="big" weight="regular">
          Gracias por elegir {nombreFantasia ? nombreFantasia : 'Ecommerce'}
        </Paragraph>     
      </div>
    </div>
  </CustomModal>

}


PedidoErrorPago.propTypes = {
  classes: PropTypes.string.isRequired,
  openModalCompraNoExitosa: PropTypes.func.isRequired,
  handleOnClickEntendido: PropTypes.func.isRequired,
}

export default PedidoErrorPago;
